export default __webpack_public_path__ + "static/media/books_light.8ad6c62b.png";